<template>
    <div>
        <h1>{{ $t('validation.errorHeader') }}</h1>
        <div class="ct-card">
            <section class="top-margin">
                <div v-if="showMessage" class="ct-text alert alert-danger" role="alert">
                    {{ $t(messageKey) }}
                </div>
            </section>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import RegistrationClient from './RegistrationClient';
import * as types from '../store/mutation-types';

export default {
    data() {
        return {
            showMessage: false,
            messageKey: ''
        };
    },
    components: {},
    mounted() {
        this.$store.commit(types.LANGUAGE_CHANGE, this.$route.params.registrationLanguage);
        let that = this;

        RegistrationClient.validateEmail(this.$route.params.validationToken)
            .then(function() {
                that.$router.push({ name: 'SetupStatus', params: { token: that.$route.params.validationToken } });
            })
            .catch(error => {
                that.messageKey = error.response.data.messageKey;
                that.showMessage = true;
            });
    }
};
</script>
<style>
.ct-card .ct-text.ct-token {
    text-align: center;
    white-space: pre;
}
</style>
